<template lang="pug">
.m-card
  .m-card-header(:id="'heading-oxtou-' + id" :data-bs-target="'#collapse-oxtou-' + id" :aria-controls="'collapse-oxtou-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_1X2OU", 1) }}
  .m-card-body.collapse.show(:id="'collapse-oxtou-' + id" :aria-labelledby="'heading-oxtou-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T  
          .odds-group
            template(v-for="item in col")
              template(v-if="moreItems['oxtouo'][item] && moreItems['oxtouo'][item][5] != 0 && moreItems['oxtouo'][item][5] != ''")
                OddsItem.col-more-scroll(:odds="moreItems['oxtouo'][item]" idx=5 :typ="oddsType" dataType="3" :label="getLabel(item)")
              template(v-else)
                OddsDisabled.col-more-scroll
//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-oxtou-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-oxtou-' + id"
//-     :aria-controls="'collapse-oxtou-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_1X2OU") }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-oxtou-' + id"
//-     :id="'collapse-oxtou-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group(v-for="item in col")
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_" + item) }} ({{ moreItems['oxtouo'][item][7] }})
//-               template(v-if="moreItems['oxtouo'][item] && moreItems['oxtouo'][item][5] != 0 && moreItems['oxtouo'][item][5] != ''")
//-                 OddsItem(:odds="moreItems['oxtouo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="oxtouo")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col: ["1O", "1U", "XO", "XU", "2O", "2U"],
    }
  },
  methods: {
    getLabel(x) { 
      if(this.moreItems['oxtouo'][x] && this.moreItems['oxtouo'][x][7] && this.moreItems['oxtouo'][x][7] != '') {
        return this.$t("m.BT_" + x) + ' (' + this.moreItems['oxtouo'][x][7] + ')';
      }
      return this.$t("m.BT_" + x);
    },  
  }
}
</script>
